import script from "./RecentActivityCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentActivityCard.vue?vue&type=script&setup=true&lang=js"

import "./RecentActivityCard.vue?vue&type=style&index=0&id=0019fd2b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0019fd2b"]])

export default __exports__